import React from 'react';

import { createStrings } from '@utils/local';

export const paymentSlipBatchStrings = createStrings({
  ja: {
    batch: 'バッチ',
    batch_no: 'バッチ番号',
    payment_slip_batch: '支払バッチ',
    payment_date: '支払予定日',
    deadline: '締め日',
    payment_amount: '支払金額',
    payee: '支払先',
    payee_ja: '支払先(和文)',
    invoice_files: '請求書',
    withdraw_date: '出金日',
    withdraw_certificate_files: '出金証明書',
    withdraw_no: '出金番号',
    payment_status: '支払状況',
    paid: '済',
    unpaid: '未',
    add: '追加',
    remove: '解除',
    delete: '削除',
    has: '有',
    no: '無',
    batchDetails: 'バッチ詳細',
    paymentSlipList: '支払伝票一覧',
    batchInfo: 'バッチ情報',
    totalAmount: '合計金額',
    ableToInputAfterWithdraw: '出金後に入力可能',
    createBatch: 'バッチ作成',
    belowIsForAccounting: '以下経理用',
    withdrawDateRequired: '出金番号と共に出金日を入力してください',
    batchCreated: (batchNo: React.ReactNode) => (
      <>
        支払バッチ作成完了。バッチ番号は：<>{batchNo}</>
      </>
    ),
    pleaseSelectPaymentSlip: '支払伝票を選択してください',
    payeeMustBeTheSame: '支払先はいずれも同じである必要があります',
    paymentSlipMustNotBePaid: '支払伝票は支払済みであってはなりません',
    paymentSlipMustBeCreated: '支払伝票は作成済みである必要があります',
    tagSearchInputPlaceholder: '支払先、バッチ番号などの検索条件を入力してください',
    paymentSlipAlreadyBatched: '既にバッチに追加されている支払伝票があります',
    pleaseConfirmRemoveFrom: (batchNo: string) =>
      `下記の支払伝票を「${batchNo}」から解除します。ご確認ください。`,
    batchIsDeleted: (batchNo: string) => `「バッチ番号：${batchNo}」を削除します。`,
    operationCannotBeUndone: 'この操作は元には戻せません',
    isItOkToDelete: '削除してもよろしいですか？',
    cannotEditPaidBatch: '支払済みのバッチは編集できません',
  },
} as const);
